/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Mute_Members_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to mute other members in voice channels for everyone." |
*
* @param {Leveling_Perm_Mute_Members_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_mute_members_hint = /** @type {((inputs?: Leveling_Perm_Mute_Members_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Mute_Members_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отключать микрофон другим участникам в голосовых каналах — для всех.")
	return /** @type {LocalizedString} */ ("Allows members to mute other members in voice channels for everyone.")
});